/**
 * LD.CLPBP.Public.Service
 * No descripton provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

'use strict';
import * as models from './models';

export interface LDCLPBPPublicApiModelsLoanApplicationsTasksLoanApplicationTask {
    

    guid?: string;

    loanApplicationGuid?: string;

    userGuid?: string;

    type?: LDCLPBPPublicApiModelsLoanApplicationsTasksLoanApplicationTask.TypeEnum;

    status?: LDCLPBPPublicApiModelsLoanApplicationsTasksLoanApplicationTask.StatusEnum;

    title?: string;

    requestMessage?: string;

    requestedUploadedDocumentTypes?: Array<LDCLPBPPublicApiModelsLoanApplicationsTasksLoanApplicationTask.RequestedUploadedDocumentTypesEnum>;

    isRequired?: boolean;

    uploadedDocuments?: Array<models.LDCLPBPPublicApiModelsDocumentsUploadedDocument>;

    requestedBy?: string;

    dateRequested?: Date;

    dateCompleted?: Date;
}
export namespace LDCLPBPPublicApiModelsLoanApplicationsTasksLoanApplicationTask {

    export enum TypeEnum { 
        UpdateEmployment = <any> 'UpdateEmployment',
        UpdateEmploymentEmployed = <any> 'UpdateEmploymentEmployed',
        UpdateEmploymentSelfEmployed = <any> 'UpdateEmploymentSelfEmployed',
        UpdateEmploymentMilitary = <any> 'UpdateEmploymentMilitary',
        UpdateEmploymentRetired = <any> 'UpdateEmploymentRetired',
        UpdateEmploymentOther = <any> 'UpdateEmploymentOther',
        UpdateEmploymentUnemployed = <any> 'UpdateEmploymentUnemployed',
        UpdateHomePayment = <any> 'UpdateHomePayment',
        LinkBankAccount = <any> 'LinkBankAccount',
        VerifyBankAccount = <any> 'VerifyBankAccount',
        WaitForTrialDeposit = <any> 'WaitForTrialDeposit',
        ValidateTrialDeposit = <any> 'ValidateTrialDeposit',
        UploadDocument = <any> 'UploadDocument',
        VerifyEmail = <any> 'VerifyEmail',
        SubmitLoanApplication = <any> 'SubmitLoanApplication',
        SignLoanPacket = <any> 'SignLoanPacket',
        FundingDocs = <any> 'FundingDocs',
        Expired = <any> 'Expired',
        ReapplyNow = <any> 'ReapplyNow',
        Withdrawn = <any> 'Withdrawn',
        Declined = <any> 'Declined',
    }

    export enum StatusEnum { 
        NotStarted = <any> 'NotStarted',
        InProgress = <any> 'InProgress',
        Completed = <any> 'Completed',
        Failed = <any> 'Failed',
    }

    export enum RequestedUploadedDocumentTypesEnum { 
        PhotoId = <any> 'PhotoId',
        StateID = <any> 'StateID',
        DriversLicense = <any> 'DriversLicense',
        Passport = <any> 'Passport',
        GreenCard = <any> 'GreenCard',
        SocialSecurityCard = <any> 'SocialSecurityCard',
        BirthCertificate = <any> 'BirthCertificate',
        MarriageCertificate = <any> 'MarriageCertificate',
        PropertyTaxBill = <any> 'PropertyTaxBill',
        UtilityBill = <any> 'UtilityBill',
        BankStatement = <any> 'BankStatement',
        VoidedCheck = <any> 'VoidedCheck',
        BankTransactionDetail = <any> 'BankTransactionDetail',
        PayStubs = <any> 'PayStubs',
        LeaveAndEarningsStatement = <any> 'LeaveAndEarningsStatement',
        W2 = <any> 'W2',
        TaxReturn = <any> 'TaxReturn',
        SocialSecurityAwardLetter = <any> 'SocialSecurityAwardLetter',
        PensionOrRetirement = <any> 'PensionOrRetirement',
        InterestOrDividendAccount = <any> 'InterestOrDividendAccount',
        RetirementAccount = <any> 'RetirementAccount',
        RentalAgreement = <any> 'RentalAgreement',
        Form1099 = <any> 'Form1099',
        ChildSupportCourtOrder = <any> 'ChildSupportCourtOrder',
        ChildSupportIncome = <any> 'ChildSupportIncome',
        DivorceDecree = <any> 'DivorceDecree',
        AlimonyIncome = <any> 'AlimonyIncome',
        DisabilityIncome = <any> 'DisabilityIncome',
        DisabilityAwardLetter = <any> 'DisabilityAwardLetter',
        AlternateIncome = <any> 'AlternateIncome',
        AgentRequested = <any> 'AgentRequested',
        CurrentProofOfReceipt = <any> 'CurrentProofOfReceipt',
        ProofOfIncome = <any> 'ProofOfIncome',
        Other = <any> 'Other',
    }
}
